import React, { useMemo, useRef } from 'react';
import { Button } from 'antd';
import { groupMembers } from '@/utils/memberDirectory';

const MemberDirectory = ({ members, group, renderMember }) => {
  const groups = useMemo(() => groupMembers(members, group), [members, group]);
  const sections = useRef(new Map());
  return <div className="message-members-directory">
    <div className="message-members-directory-list">
      {groups.map(section => <section key={section.key} ref={node => { if (node) sections.current.set(section.key, node); else sections.current.delete(section.key); }}>
        <h3>{section.label} <span>（{section.items.length}）</span></h3>
        {section.items.map(renderMember)}
      </section>)}
    </div>
    {groups.length > 1 && <nav className="message-members-directory-index" aria-label="成员首字母索引">
      {groups.map(section => <Button key={section.key} type="text" aria-label={`跳转到${section.label}`} onClick={() => {
        sections.current.get(section.key)?.scrollIntoView({ block: 'start', behavior: 'auto' });
      }}>{section.key === 'owner' ? '主' : section.key}</Button>)}
    </nav>}
  </div>;
};

export default MemberDirectory;
